import React from "react";
import "../style.css";


export default class SectionAbout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titel: props.titel,
      beschreibung: props.beschreibung,
      image_01: props.image_01,
      image_02: props.image_02
    };
  }

  render() {
    return (
      <div className="card-wrapper" style={{ alignItems: "center"}}>
        <div className="card-about" style={{ aspectRatio: "4 / 5" }}>
          <img
            src={this.state.image_01}
            style={{ objectFit: "cover", aspectRatio: "4 / 5", objectPosition: "center 27.5%" }}
            className="image"
            alt="Erik Schott lächelt, trägt eine schwarze Jacke und hält eine Kamera, stehend an einer Steinsäule"
          />
        </div>
        <div className="card-about" style={{ width: "100%" }}>
          <div className="h3">
            {this.state.titel}
          </div>
          <div
            className="bodycopy"
            style={{ whiteSpace: "pre-line", width: "100%" }}
            dangerouslySetInnerHTML={{ __html: this.state.beschreibung }}
          />
          {/* Font Awesome self-hosted for GDPR compliance */}
        </div>
      </div>
    );
  }
}
